import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/oldHiyawallet',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-Wallet" */ '~/pages/wallet2/Diamonds')
    ),
  },
  {
    path: '/hiyawallet/extra',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-rechargeExtra" */ '~/pages/wallet2/rechargeExtra'
        )
    ),
  },
  {
    path: '/hiyawallet/stripe/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-stripe" */ '~/pages/wallet2/stripe'
        )
    ),
  },
  {
    path: '/hiyawallet/checkout/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-checkout" */ '~/pages/wallet2/checkout'
        )
    ),
  },
  {
    path: '/hiyawallet/airwallex/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-airwallex" */ '~/pages/wallet2/airwallex'
        )
    ),
  },
  {
    path: '/hiyawallet/airwallex/googlepay/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-airwallex-googlepay" */ '~/pages/wallet2/airwallex/googlepay'
        )
    ),
  },
  {
    path: '/hiyawallet/airwallex/applepay/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-airwallex-applepay" */ '~/pages/wallet2/airwallex/applepay'
        )
    ),
  },
  {
    path: '/hiyawallet/PayPal/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-PayPal" */ '~/pages/wallet2/PayPal'
        )
    ),
  },
  {
    path: '/hiyawallet/pandaPay/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-PandaPay" */ '~/pages/wallet2/PandaPay'
        )
    ),
  },
  {
    path: '/hiyawallet/payoneer',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-payoneer" */ '~/pages/wallet2/payoneer'
        )
    ),
  },
  {
    // payoneer验证码支付后的中间页
    path: '/hiyawallet/payoneer/vacant',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-payoneer-vacant" */ '~/pages/wallet2/payoneer/vacant'
        )
    ),
  },
  // 钱包充值的重定向页面 需要配置的成功重定向页面都走这个
  {
    path: '/hiyawallet/redirect/:name',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-stripe" */ '~/pages/wallet2/redirect'
        )
    ),
  },
] as RouteConfig[]
